import React, { useEffect, useContext } from 'react';

import { initEsriGlobalNav } from '../../utils/esri-global-nav';
import { EsriOAuthContext } from '../../contexts/EsriOAuthProvider'

const EsriGlobalNav:React.FC = () => {

    const { signIn, signOut, userData } = useContext(EsriOAuthContext);

    useEffect(()=>{
        initEsriGlobalNav({
            userData,
            signIn,
            signOut,
        });
    }, [])

    return null;
}

export default EsriGlobalNav
